// CANONICAL COPY (GH #7115). src/constants/obligations/obl-isms-communication-awareness.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-isms-communication-awareness',
  title: 'Review ISMS communication and awareness plan',
  description:
    'Determine the internal and external communications relevant to the ISMS (who communicates, with whom, when and how) and confirm that relevant persons are aware of the information security policy, their contribution to the ISMS, and the implications of non-conformance.',
  category: 'governance',
  scfIds: ['SCF-MSS-003'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'ISMS communication and awareness plan is published',
    },
    { type: 'document-acknowledged', description: 'Relevant personnel have acknowledged the plan' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
